export const safeNumber = (value: unknown): number => {
  return Number.isFinite(Number(value)) ? Number(value) : 0;
};

/** Positive finite integer from a number or numeric string; otherwise `undefined`. */
export const normalizePositiveIntId = (value: unknown): number | undefined => {
  if (typeof value === "number" && Number.isFinite(value) && value > 0) {
    return Math.trunc(value);
  }
  if (typeof value === "string" && value.trim() !== "") {
    const n = Number(value);
    if (Number.isFinite(n) && n > 0) {
      return Math.trunc(n);
    }
  }
  return undefined;
};

export const isValidPositiveNumber = (value: unknown): value is number => {
  return typeof value === "number" && value > 0;
};

// Returns undefined for invalid values instead of 0
export const safeParseNumericStringOrUndefined = (
  value: unknown,
): number | undefined => {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  // Handle number type
  if (typeof value === "number") {
    if (isNaN(value) || !isFinite(value)) {
      return undefined;
    }
    return value;
  }

  // Handle string type
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") {
      return undefined;
    }

    const parsed = Number(trimmed);
    if (isNaN(parsed) || !isFinite(parsed)) {
      return undefined;
    }
    return parsed;
  }

  return undefined;
};
